import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet-async';
import Navbar from "../components/Navbar";
import axios from "axios";
import { secretKey, baseURL } from "../utils/constant";
import Image1 from "../assets/images/shop/image-1.jpg";
import Image2 from "../assets/images/shop/image-2.png";
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from "react-router-dom";

function Arabic({ setPageTitle }) {
  const [isLoading, setIsLoading] = useState(false);
  const [products, setProducts] = useState({});
  const headers = {
    Authorization: `Bearer ${secretKey}`,
    "Content-Type": "application/x-www-form-urlencoded",
  };


  useEffect(() => {
    setPageTitle("Arabian Ethereals - Bait Al Anaqah");
    // const query = "active:'true' AND metadata['western']:'western'";
    const query = "active:'true' AND metadata['arabic']:'arabic'";
    axios
      .get(`${baseURL}/v1/products/search`, {
        headers: { ...headers },
        params: {
          query
        }
      })
      .then((response) => {
        console.log(response.data.data);
        setIsLoading(false);
        setProducts(response.data.data)
      })

      .catch((err) => {
        // toast(err?.response?.data?.message, {
        //   position: "bottom-left",
        //   autoClose: 5000,
        //   hideProgressBar: true,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   theme: "colored",
        // });
        console.log("Errror in API Call");
      });
  }, [setPageTitle]);




  return (
    <>
    <Helmet>
        <meta name="keywords" content="Bait Al Anaqah, Bespoke, Uniforms, Alteration, Custom, Dubai" />
        <meta name="title" property="og:title" content={setPageTitle}></meta>
        <meta property="og:type" content="website" />
        <meta name="description" property="og:description" content="Experience the elegance of Bait Al Anaqah, where every creation tells a story and reflects your unique identity while honoring your values." />
        <meta name="image" property="og:image" content={Image2} />
        <link rel="canonical" href="https://baitalanaqah.com/arabian-ethereals" />
      </Helmet>
      <Navbar />
      <Container className="py-3">
        <Row>
        {isLoading ? (
            <Col>
              <p>Loading...</p>
            </Col>
          ) : products.length > 0 ? (
            products.map((product, index) => (
              <Col lg={3} key={index} className="mx-auto">
                <img src={product.images} className="img-fluid mb-3"/>
                <p className="text-muted">{product.name || "Unnamed Product"}</p> {/* Fallback if name is missing */}
              </Col>
            ))
          ) : (
            <Col className="text-center py-3">
              <p className="text-muted">No products to display</p>
            </Col>
          )}
        </Row>
      </Container>
    </>
  );
}

export default Arabic;
